<template>
  <v-container fluid class="px-md-16" :class="classes">
    <h1 v-if="title" class="font-weight-regular text-center pb-6">{{ title }}</h1>
    <v-row v-if="cars != null && cars.length > 0" justify="start">
      <v-col
        v-for="car in cars"
        :key="car.id"
        cols="12"
        md="6"
        lg="4"
        class="px-0 px-md-2 pt-0 mb-md-8"
      >
        <v-car-card :car="car" @click="viewCar(car.id)"/>
      </v-col>
    </v-row>

    <v-row v-else-if="cars != null" justify="center" align="center" style="height: 200px">
      <v-col class="text-center">
        <div class="text-subtitle-2 grey--text text--darken-3">Sorry but we don't have what you're looking for.</div>
        <v-btn outlined class="mt-2" @click="$router.push('/')">Go to homepage</v-btn>
      </v-col>
    </v-row>

    <!-- skeleton-loader -->
    <v-row v-else justify="start">
      <v-col
        v-for="i in skeletons"
        :key="i"
        cols="12"
        md="6"
        lg="4"
        class="px-0 px-md-10"
      >
        <v-skeleton-loader
          boilerplate
          type="card, article"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

import VCarCard from "./VCarCard.vue";

export default {
  props: ['title', 'cars'],
  computed: {
    skeletons() {
      const bp = this.$vuetify.breakpoint
      return bp.lgAndUp ? [0,1,2] : (bp.md ? [0,1] : [0])
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    classes() {
      return {
        'grey lighten-2': this.isMobile,
        'mt-8': !this.isMobile
      }
    }
  },

  methods: {
    viewCar(id) {
      this.$router.push(`/car/${id}`)
    }
  },

  components: { VCarCard },
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");

h1 {
  font-family: "Bebas Neue", cursive;
  font-size: 4em;
}
</style>